import React from 'react';

import PropTypes from 'prop-types';

import { LayoutContainer as ContainerQueryLayoutContainer } from './container-query/layout-container';
import { LayoutContainer as ResizeObserverLayoutContainer } from './resize-observer-fallback/layout-container';
import { doesBrowserSupportContainerQuery } from '../../../../services/browser-support-service';

export const ReturnDetailsLayoutLoader = (props) => {
  if (doesBrowserSupportContainerQuery) {
    return <ContainerQueryLayoutContainer {...props} />;
  }

  return <ResizeObserverLayoutContainer {...props} />;
};

ReturnDetailsLayoutLoader.propTypes = {
  addressColumnContent: PropTypes.node.isRequired,
  dateColumnContent: PropTypes.node.isRequired,
  rmaColumnContent: PropTypes.node.isRequired,
};
